<template>
  <div class="mb-2">
    <template v-if="links.length">
      <small class="d-block mb-3">
        Existing Anchor Texts
      <b-icon-info-circle v-b-tooltip.hover="'These are the anchor text variations we found on your site that link back to this page.'"/>
      </small>
      <div v-for="link in links" :key="link.id" class="word-list-item mb-1">
        <b-row no-gutters>
          <b-col class="text-muted small mr-1 link_text" :title="link.text">{{ (link.text || '“”') | truncate(30) }}</b-col>
          <b-col cols="3" class="text-right">
            <b-link class="small" v-b-toggle="`accordion-${link.id}`">{{link.page_links_aggregate.aggregate.count|formatNumber}}</b-link>
          </b-col>
        </b-row>
        <b-collapse :id="`accordion-${link.id}`" accordion="links-accordion" role="tabpanel" class="my-1">
          <div v-for="pagelink of link.page_links" :key="pagelink.id" class="text-small d-flex justify-content-between">
            <div>
            <b-link :href="pagelink.page.url" target="_blank" class="text-muted">
              <span class="page_url">{{pathname(pagelink.page.url) | truncate(32)}}</span>
              <b-icon-box-arrow-up-right class="ml-1"/>
            </b-link>
            </div>
            <div class="text-muted">
              <b-icon-image v-if="pagelink.is_image" v-b-tooltip="'Image link'" class="ml-1" />
              <b-icon-text-indent-left v-if="pagelink.in_content" v-b-tooltip="'Link in page content'" class="ml-1" />
              <b-icon-x-square v-if="pagelink.is_nofollow" v-b-tooltip="'Nofollow link'" class="ml-1" />
            </div>
          </div>
          <!-- <b-link href="#" class="text-small" v-if="link.page_links_aggregate.aggregate.count > link.page_links.length">
            ... {{link.page_links_aggregate.aggregate.count - link.page_links.length}} more
          </b-link> -->
        </b-collapse>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'AnchorTexts',
  props: ['links'],
  components: {},
  data: () => {
    return {
    }
  },

  methods: {
    pathname(url) {
      return new URL(url).pathname
    }
  }
}
</script>
